(function() {
	'use strict';

	angular
		.module('accesso-pay')
		.controller('AccessoPayController', AccessoPayController);

	/**
	 * Our AccessoPayController.
	 * @public
	 * @constructor
	 * @param {Service} $rootScope rootScope
	 * @param {Service} AccessoPayService AccessoPayService
	 * @param {Service} Utilities Utilities
	 * @returns {undefined}
	 * @ngInject
	 */
	function AccessoPayController($rootScope, AccessoPayService, Utilities) {
		var vm = this;

		vm.currentRoute = AccessoPayService.getCurrentRoute;
		vm.isInIframe = Utilities.isInIFrame();
		vm.steps = [{
			label: 'shippingLabel',
			name: 'delivery'
		}, {
			label: 'billingLabel',
			name: 'select'
		}];
		vm.initialize = initialize;

		vm.initialize();

		/**
		 * Initialize controller
		 * @returns {undefined}
		 */
		function initialize() {
			$rootScope.showSpinner();
			AccessoPayService.mountAccessoPay();
		}
	}
})();
